import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App, type AppProps } from '../components/App';
import { setSubVertical } from '../utils/tracking';
import '../styles/carousel.css';

const ROOT_ID = 'effect-meglerpromo-podlet-root';
const CONFIG_ID = 'effect-meglerpromo-podlet-config';

const shadowRoot = document.querySelector('effect-meglerpromo-podlet')?.shadowRoot;

const root = shadowRoot?.getElementById(ROOT_ID) ?? document.getElementById(ROOT_ID);
const configElement = shadowRoot?.getElementById(CONFIG_ID) ?? document.getElementById(CONFIG_ID);

if (root && configElement?.textContent) {
    const props = JSON.parse(configElement.textContent) as AppProps;
    setSubVertical(props.subVertical);
    hydrateRoot(root, createElement(App, props));
}
